import { DIRECTUS_INSTANCE } from '../../api';
import axios from 'axios';

/**
 * Uploads an image file to Directus and returns the response in Editor.js compatible format
 * @param {File} file - The image file to upload
 * @returns {Promise<{success: number, file?: {url: string, id: string}, error?: string}>}
 */
export const uploadImageToDirectus = async (file) => {
  const token = localStorage.getItem('directus_token') || sessionStorage.getItem('directus_token');

  if (!token) {
    console.error('Authentication token not found');
    return {
      success: 0,
      error: 'Authentication token not found. Please log in again.'
    };
  }

  const formData = new FormData();
  formData.append('file', file);

  const folderId = 'a449f44e-926b-4940-9f46-0f5017223089';
  formData.append('folder', folderId);

  try {
    const response = await axios.post(`${DIRECTUS_INSTANCE}/files`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${token}`
      }
    });

    if (!response.data || !response.data.data) {
      return {
        success: 0,
        error: 'Invalid response from server'
      };
    }

    const imageUrl = `${DIRECTUS_INSTANCE}/assets/${response.data.data.id}`;

    return {
      success: 1,
      file: {
        url: imageUrl,
        id: response.data.data.id,
        name: response.data.data.filename_download,
        size: response.data.data.filesize,
        extension: response.data.data.type
      }
    };
  } catch (error) {
    let errorMessage = 'Failed to upload image';

    if (error.response) {
      errorMessage = `Server error: ${error.response.status}`;
      if (error.response.data && error.response.data.errors) {
        errorMessage += ` - ${error.response.data.errors[0]?.message || JSON.stringify(error.response.data.errors)}`;
      }
    } else if (error.request) {
      errorMessage = 'No response from server. Please check your connection.';
    } else {
      errorMessage = error.message || 'An unknown error occurred';
    }

    return {
      success: 0,
      error: errorMessage
    };
  }
};
